import type { Resource } from '@/types';

/** Curated external learning platforms, shown as a simple ranked list. */
export const RESOURCES: readonly Resource[] = [
  {
    title: 'موقع Coursera',
    description: 'منصة عالمية توفر دورات تعليمية عالية الجودة من جامعات عريقة.',
    url: 'https://www.coursera.org/',
    icon: 'description',
  },
  {
    title: 'edX',
    description: 'منصة تعليمية متخصصة في دورات من أفضل الجامعات العالمية.',
    url: 'https://www.edx.org/',
    icon: 'account_balance',
  },
  {
    title: 'Udemy',
    description: 'منصة تعليمية بها آلاف الدورات في مختلف المجالات.',
    url: 'https://www.udemy.com/',
    icon: 'star',
  },
  {
    title: 'Google for Education',
    description: 'موارد تعليمية من جوجل خاصة بالمعلمين والطلاب.',
    url: 'https://edu.google.com/',
    icon: 'language',
  },
  {
    title: 'Khan Academy',
    description: 'مكتبة ضخمة من مقاطع الفيديو التعليمية والتمارين التفاعلية.',
    url: 'https://www.khanacademy.org/',
    icon: 'video',
  },
  {
    title: 'Pinterest for Educators',
    description: 'مجتمع تعليمي يشارك أفكار ودروس تعليمية إبداعية.',
    url: 'https://www.pinterest.com/',
    icon: 'grid_view',
  },
] as const;
